import type {
  AssessmentClientActionType,
  IAssessmentClientItem,
  IAssessmentClientState,
} from '../../types';

export function reduceActiveAssessmentClientState<TItem extends IAssessmentClientItem, TResult>(
  state: IAssessmentClientState<TItem, TResult>,
  action: AssessmentClientActionType<TItem, TResult>,
): IAssessmentClientState<TItem, TResult> {
  if (action.type === 'answer_submitted') {
    return { ...state, error: null, phase: 'submitting' };
  }
  if (action.type === 'media_replaced') {
    return { ...state, currentItem: action.item, currentToken: action.token, error: null };
  }
  return state;
}
